<template>
  <div class="tw-flex tw-items-center tw-gap-x-2" :class="[dragHandle ? 'tw-cursor-grab' : 'tw-pl-6', labelColorClass]">
    <Icon v-if="dragHandle" :path="DragSvg" class="tw-size-4 tw-shrink-0 tw-fill-white" />
    <Checkbox
      :model-value="modelValue"
      :right-label="stationLabel"
      @update:model-value="(value) => emit('update:modelValue', value)"
      :right-label-attrs="{ class: labelColorClass }"
    />

    <template v-if="station.status === 'loading'">
      <Spinner size="small" />
    </template>

    <template v-else-if="station.status === 'ok'">
      <span class="tw-h-2 tw-w-2 tw-rounded-full tw-bg-state-succ" />
    </template>

    <template v-else>
      <span v-tooltip="statusMessage">
        <Icon name="warning" class="tw-size-4 tw-fill-current" :class="statusColorClass" />
      </span>
      <Text v-if="station.online" size="small" :class="statusColorClass">{{ statusLabel }}</Text>
    </template>
  </div>
</template>

<script setup>
import { computed } from 'vue';

import { Checkbox, Icon, Spinner, Text } from '@slideslive/fuse-kit/vue';

import DragSvg from '@/assets/mdi/drag.svg';
import useStation from '@/composables/use_station';

const props = defineProps({
  station: { type: Object, required: true },
  modelValue: { type: Boolean, default: false },
  dragHandle: { type: Boolean, default: false },
});

const emit = defineEmits(['update:modelValue']);

const { stationLabel, statusLabel, statusMessage, statusColorClass } = useStation({ station: () => props.station });

const labelColorClass = computed(() => {
  if (!props.station.online && props.station.status !== 'ok') return 'tw-text-state-err';

  return '';
});
</script>
